import { render, staticRenderFns } from "./ConsentComponent.vue?vue&type=template&id=4d4fc227&scoped=true&"
import script from "./ConsentComponent.vue?vue&type=script&lang=js&"
export * from "./ConsentComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConsentComponent.vue?vue&type=style&index=0&id=4d4fc227&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fc227",
  null
  
)

export default component.exports